export interface PriceEntry {
  area: string;
  date: string;
  deliveryStart: string;
  deliveryEnd: string;
  priceOreKwh: number;
}

export interface CurrentPrice {
  area: string;
  areaName: string;
  priceOreKwh: number;
  timeStart: string;
  timeEnd: string;
}

export interface DayPricesResponse {
  area: string;
  date: string;
  prices: PriceEntry[];
}

export interface ApiError {
  error: string;
  code?: string;
  area?: string;
  date?: string;
}

export const AREA_NAMES: Record<string, string> = {
  SE1: 'Luleå',
  SE2: 'Sundsvall',
  SE3: 'Stockholm',
  SE4: 'Malmö',
};

export const AREAS = ['SE1', 'SE2', 'SE3', 'SE4'] as const;
export type Area = (typeof AREAS)[number];
